// assets
import {
    Article,
    Campaign,
    Chat,
    Description,
    DocumentScanner,
    FolderCopy,
    FormatListBulleted,
    Groups,
    Mail,
} from "@mui/icons-material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import { RoleLevel } from "../../../../../../../domain/entities/Role";

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const requestor = {
  id: "requestor",
  title: "Signature Requests",
  caption: "Request document signatures",
  type: "group",
  level: RoleLevel.SignatureRequestor,
  children: [
    {
      id: "sendToStaff",
      title: "Send to Staff",
      type: "collapse",
      icon: BadgeOutlinedIcon,
      color: "#7B1FA2",
      children: [
        {
          id: "campaignsStaff",
          title: "Communications",
          type: "item",
          icon: Campaign,
          color: "#7B1FA2",
          url: "/campaignsStaff",
          breadcrumbs: false,
        },
        {
          id: "messagesStaff",
          title: "Messages",
          type: "item",
          icon: Mail,
          color: "#7B1FA2",
          url: "/messagesStaff",
          breadcrumbs: false,
        },
        {
          id: "documentsStaff",
          title: "Staff Documents",
          type: "item",
          icon: Article,
          color: "#7B1FA2",
          url: "/documentsStaff",
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "sendToParents",
      title: "Send to Parents",
      type: "collapse",
      icon: FamilyRestroomIcon,
      color: "#1976D2",
      children: [
        {
          id: "campaigns",
          title: "Communications",
          type: "item",
          icon: Campaign,
          color: "#1976D2",
          url: "/campaigns",
          breadcrumbs: false,
        },
        {
          id: "messages",
          title: "Messages",
          type: "item",
          icon: Mail,
          color: "#1976D2",
          url: "/messages",
          breadcrumbs: false,
        },
      ],
    },
    {
      id: "documentsAndCampaigns",
      title: "Documents & Packages",
      type: "collapse",
      icon: DocumentScanner,
      color: "#00ACC1",
      children: [
        {
          id: "packages",
          title: "Packages",
          type: "item",
          icon: FolderCopy,
          color: "#00ACC1",
          url: "/packages",
          breadcrumbs: false,
        },
        {
          id: "documents",
          title: "Documents",
          type: "item",
          icon: Description,
          color: "#00ACC1",
          url: "/documents",
          breadcrumbs: false,
        },
        {
          id: "selectRoutingsTable",
          title: "Select Routings",
          type: "item",
          icon: FormatListBulleted,
          color: "#00ACC1",
          url: "/selectRoutings",
          breadcrumbs: false,
        },
      ],
    }, 
    {
      id: "signatoryGroups",
      title: "Recipient Lists",
      type: "item",
      icon: Groups,
      color: "#43A047",
      url: "/recipientgroups",
      breadcrumbs: false,
    },
    {
      id: "chatCommunications",
      title: "Conversations",
      type: "item",
      icon: Chat,
      color: "#F9A825",
      url: "/chatCommunications",
      breadcrumbs: false,
    },
    {
      id: "studentHistory",
      title: "Document Finder",
      type: "item",
      icon: AssignmentIcon,
      color: "#B71C1C",
      url: "/studentHistory",
      breadcrumbs: false,
    },
  ],
};

export default requestor;
